<div *ngIf='(vm$ | async) as vm'>

    <div *ngIf="vm.workingText">
        <span>{{vm.workingText}}</span>
    </div>
    <div *ngIf="vm.errorText">
        <h1 class="text-danger">{{vm.errorText}}</h1>
    </div>

    <div *ngIf="!vm.workingText && !vm.errorText">
        <div class="pt-3" *ngIf="vm.pendingRealTimesBreaksVm as rts">
            <div class="container">
                <div class="col-md-12">
                    <mdb-card narrower="true" cascade="true">
                        <app-card-header title="Meal Start/Meal End"
                            [headingSize]="6"></app-card-header>
                        <mdb-card-body cascade="true">
                            <div class="d-flex justify-content-center flex-wrap gap-2">
                                <ng-container *ngIf="rts.restBreakSupported">
                                    <button mdbBtn color="info" outline="true" rounded="true" size="sm"
                                        style="white-space: nowrap; min-width: 200px;" mdbWavesEffect type="submit"
                                        (click)="restBreakClockInOut(rts.payrollPeriodDriverDayId, vm)"
                                        [disabled]="!rts.restBreakAllowed && !rts.restBreakEndAllowed">
                                        {{ rts.restBreakEndAllowed ? 'Rest End' : 'Rest Start' }}
                                    </button>
                                </ng-container>

                                <ng-container *ngIf="rts.mealBreakSupported">
                                    <button mdbBtn color="info" outline="true" rounded="true" size="sm"
                                        style="white-space: nowrap; min-width: 200px;" mdbWavesEffect type="submit"
                                        (click)="mealBreakClockInOut(rts.payrollPeriodDriverDayId, vm)"
                                        [disabled]="!rts.mealBreakAllowed && !rts.mealBreakEndAllowed">
                                        {{ rts.mealBreakEndAllowed ? 'Meal End' : 'Meal Start' }}
                                    </button>
                                </ng-container>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
        <div class="container pt-3" *ngIf="vm.completedRealTimesBreaksVm as cvm">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <app-card-header title="Clocked In" [headingSize]="6"></app-card-header>
                    <mdb-card-body cascade="true">
                        <div class="row">
                            <div class="table-responsive">
                                <table class="table table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">Break Type</th>
                                            <th scope="col">Start</th>
                                            <th scope="col">End</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let c of cvm.data" (click)="onClockedInRowClick(c.id)"
                                            style="cursor: pointer;">
                                            <td class="text-info"><u>{{c.breakType | breakTypeDescr }}</u></td>
                                            <td class="text-info"><u>{{c.startAt.time }}</u></td>
                                            <td class="text-info" *ngIf="c.endAt"><u>{{ c.endAt.time }}</u></td>
                                            <td class="text-info" *ngIf="!c.endAt"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
        <div class="container pt-3" *ngIf="vm.pendingSignatureVm as ps">
            <div class="col-md-12">
                <mdb-card narrower="true" cascade="true">
                    <app-card-header title="Pending Signature" [headingSize]="6"></app-card-header>
                    <mdb-card-body cascade="true">
                        <div class="row">
                            <div class="table-responsive">
                                <table class="table table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">Payroll Date</th>
                                            <th scope="col">Days Waiting</th>
                                            <th scope="col">Issues Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let c of ps.rows" (click)="onPendingSignatureRowClick(c)"
                                            style="cursor: pointer;">
                                            <td class="text-info"><u>{{c.payrollDate | date: 'MM'}}/{{c.payrollDate |
                                                    date:
                                                    'dd'}}/{{c.payrollDate | date: 'yyyy'}}</u></td>
                                            <td>{{c.daysWaiting }}</td>
                                            <td>{{c.issuesCount }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>
</div>